import {Typed} from "app/stimulus/typed-stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {Controller} from "@hotwired/stimulus";
import {throttle} from 'throttle-debounce';
import {ResolvableController} from "app/stimulus/resolvable-controller";

const controllerName = 'admin-side-menu';

@AsStimulusController(controllerName)
export default class extends Typed(
    ResolvableController(Controller<HTMLElement>, controllerName), {
        classes: [
            'open',
            'closed',
        ] as const,
    })
{
    private matchedBreakpointSm: boolean = false;

    public initialize(): void {
        this.onResize = throttle(100, this.onResize.bind(this));
    }

    public connect(): void {
        this.doOnResize();
    }

    public isOpened(): boolean {
        return this.element.classList.contains(this.openClass);
    }

    public toggle(): void {
        this.isOpened() ? this.close() : this.open();
    }

    public open(): void {
        this.element.classList.add(this.openClass);
        this.element.classList.remove(this.closedClass);
        this.element.style.display = '';
    }

    public close(): void {
        this.element.classList.add(this.closedClass);
        this.element.classList.remove(this.openClass);
        this.element.style.display = 'none';
    }

    public onResize(): void {
        this.doOnResize();
    }

    private doOnResize(): void {
        const root = document.documentElement;
        const breakpointSm = getComputedStyle(root).getPropertyValue('--breakpoint-sm');
        if (!this.matchedBreakpointSm && window.matchMedia('(max-width: ' + breakpointSm + ')').matches) {
            this.matchedBreakpointSm = true;
            this.close();
        } else if (this.matchedBreakpointSm && !window.matchMedia('(max-width: ' + breakpointSm + ')').matches) {
            this.matchedBreakpointSm = false;
            this.open();
        }
    }
}
